import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AsyncReduxState, initialAsyncReduxState } from '@/@config/AsyncReduxState'
import { formatDate, parseIso } from '@/helpers/date'
import { transformAtomDateToApiDateTime } from '@/helpers/date/transformAtomDateToApiDate'
import { Error } from '@/japi/types/Error'
import { DateFormat } from '@/types'

export type AppState = AsyncReduxState<{
    isOnline: boolean
    currentVersion: string
    latestVersion: string
    serverApiDateTime: string
    serverDate: Date
}>

const initialState: AppState = {
    ...initialAsyncReduxState,
    isOnline: true,
    currentVersion: '',
    latestVersion: '',
    serverApiDateTime: formatDate(new Date(), DateFormat.apiDateTime),
    serverDate: new Date(),
}

const appSlice = createSlice({
    name: 'appReducer',
    initialState,
    reducers: {
        setIsLoading(state, action: PayloadAction<boolean>): AppState {
            return {
                ...state,
                isLoading: action.payload,
            }
        },
        setIsOnline(state, action: PayloadAction<boolean>): AppState {
            return {
                ...state,
                isOnline: action.payload,
            }
        },
        setError(state, action: PayloadAction<Error | undefined>): AppState {
            return {
                ...state,
                error: action.payload,
            }
        },
        setCurrentVersion(state, action: PayloadAction<string>): AppState {
            return {
                ...state,
                currentVersion: action.payload,
            }
        },
        setLatestVersion(state, action: PayloadAction<string>): AppState {
            return {
                ...state,
                latestVersion: action.payload,
            }
        },
        setServerTime(state, action: PayloadAction<string>): AppState {
            return {
                ...state,
                serverApiDateTime: transformAtomDateToApiDateTime(action.payload),
                serverDate: parseIso(action.payload),
            }
        },
    },
})

export const {
    setIsLoading,
    setIsOnline,
    setError,
    setCurrentVersion,
    setLatestVersion,
    setServerTime,
} = appSlice.actions

export const appReducer = appSlice.reducer
